import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Seite nicht gefunden</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Hoppla! Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.</p>
        <a href="/" className="mt-8 inline-block bg-slate-900 text-white px-8 py-3 rounded-full font-bold transition-all hover:bg-primary">
           Zur Startseite
        </a>
      </div>
    </div>
  );
}
